/**
 * Shows a banner on mobile web with a sign-up CTA.
 */ export var SIGNUP_CTA_MOBILE_WEB_BANNER_240806 = 'SIGNUP_CTA_MOBILE_WEB_BANNER_240806';
